import React from "react";
import { getStorage } from "../utils/storage";
import { applyOrgTheme, resolveUrlTheme } from "../themeConfig";
import omanAirportsLogo from "../assets/fbs/oman/oman-airports.logo.webp";

/* =============================================
   FBS Common Utilities
   Shared logic across FbsLanding, FbsLandingQR, FbsOrgLanding
   ============================================= */

/* applyOrgTheme is re-exported from themeConfig.js — the single source of truth
   for all theme rules. To add/modify org themes, edit themeConfig.js. */
export { applyOrgTheme };

/**
 * Bundled logo for URL-based themes (e.g. theme-custom-oman).
 * Returns null when no URL theme supplies a default asset — then use org API / storage.
 */
export const getUrlThemeLogoAsset = () => {
    if (resolveUrlTheme() === "theme-custom-oman") return omanAirportsLogo;
    return null;
};

/* ===== RenderHeader ======
   Shared header component for FBS pages.
   Renders a logo (passed prop > stored user org logo > nothing).
   ===== / RenderHeader ====== */
export const RenderHeader = (props) => {
    const logoToUse = props.logo ?? getStorage("u4")?.hotel?.logo_img ?? null;
    return (
        <div id="header">
            <div>{/* LHS: Empty*/}</div>
            <div
                id="logo"
                style={{ cursor: "pointer" }}
                onClick={() => window.location.reload()}
            >
                {logoToUse ? <img src={logoToUse} alt="" /> : <></>}
            </div>
            <div>{/* RHS */}</div>
        </div>
    );
};

/* ===== Common FBS Helpers ====== */

export const getLocationNameLS = () =>
    getStorage("fbsMeta")?.location?.location || "Unknown";

export const getLocationIdLS = () => getStorage("fbsMeta")?.location?.id || 0;

export const getLocationIcon = () => (
    <span className="fa fa-map-pin p-r-5"></span>
);

// Shared user-facing message used when template fetch fails for scoped orgs.
export const FBS_TEMPLATE_MISSING_MESSAGE =
    "Internet connection lost. Please scan again.";

// uidGen generates a random alpha-numeric UID
export const uidGen = (len = 5) => {
    let c = "";
    for (c = ""; c.length < len; )
        c += Math.random().toString(36).toUpperCase().substr(2, 1);
    return c;
};

export const getFbsMetaLS = () => {
    let fbsMetaLS = getStorage("fbsMeta");
    return {
        tabUid: fbsMetaLS?.tabUid ?? uidGen(5),
        tabName: fbsMetaLS?.tabName ?? "TAB",
        location: fbsMetaLS?.location ?? null,
    };
};
